import React, { useEffect } from "react";
import { useState } from "react";
import Uploadphotoicon from "../../Assests/Images/uploadphotoicon.png";
import TextField from "@mui/material/TextField";
import Radio from "@mui/material/Radio";
import Box from "@mui/material/Box";
import RadioGroup from "@mui/material/RadioGroup";
import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import InfoIcon from "@mui/icons-material/Info";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { UserAPI } from "../api";
import Button from "@mui/material/Button";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import { selectUser } from "../../redux/modules/userSlice";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import SelectSkills from "../React Select/SelectSkills";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import LoadingButtons from "../Model/LoadingButtonModel";
import { toast } from "react-toastify";
import useDraft from "../../hooks/useDraft";
import DraftSavedAt from "../Shared/DraftSavedAt";
import { applySectionDraftData, pickSectionDraftData } from "../../drafts/draftHelpers";

const initialState = {
  _id: "",
  name: "",
  email: "",
  designation: "",
  doj: "",
  workLocation: "",
  aadhaar: "",
  pan: "",
  companyName: "",
  emergencyContact: [
    { name: "", contact: "", relationship: "" },
    { name: "", contact: "", relationship: "" },
  ],
  familyDetails: [
    { name: "", contact: "", relationship: "" },
    { name: "", contact: "", relationship: "" },
  ],
  secondaryEmail: "",
  mother: { name: "", occupation: "" },
  father: { name: "", occupation: "" },
  gender: "",
  dateOfBirth: null,
  bloodGroup: "",
  maritalStatus: false,
  spouse: "",
  isPassport: false,
  passport: "",
  passportExpiry: null,
  linkedIn: "",
  pf: "",
  uan: "",
  skills: [],
  currentAddress: {
    addressLine1: "",
    addressLine2: "",
    addressLine3: "",
    landmark: "",
    postalCode: "",
    periodOfStay: "",
    natureOfResidency: "",
  },
  permanentAddress: {
    addressLine1: "",
    addressLine2: "",
    addressLine3: "",
    landmark: "",
    postalCode: "",
    periodOfStay: "",
    natureOfResidency: "",
  },
  permanentAddressSame: false,
  isSodexo: false,
  sodexoCouponValue: "",
  totalExperienceInYears: "",
  totalExperienceInMonths: "",
  relevantExperienceInYears: "",
  relevantExperienceInMonths: "",
  phoneNumber: "",
  altPhoneNumber: "",
  isFresher: false,
  religion: "",
  profilePhoto: "",
  profilePhoto_fileName: "",
  signature: "",
  signature_fileName: "",
  ESIC: "",
};

function SectionA({
  changeTab,
  handleButtonClick,
  setApprovedComment,
  setReSubmitComment,
  setNewJoineeFlagButton,
}) {
  const [user, setUser] = useState(initialState);
  const [image, setImage] = useState(null);
  const [sign, setSign] = useState(true);
  const [fileName, setFileName] = useState(null);
  const [profileFileName, setProfileFileName] = useState(null);
  const params = useParams();
  const id = params.id ? params.id : "";
  const [newJoineeSectionAFlagButton, setNewJoineeSectionAFlagButton] =
    useState("");
  const [loadingbutton, setLoadingButton] = useState(false);
  const [ackChecked, setAckChecked] = useState(false);
  const [ackError, setAckError] = useState(false);
  const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,7}$/;
  const regexPassport = /^([A-Z][0-9]{7}|[A-Z]{2}[0-9]{6})$/;
  const regexPF = /^[A-Z]{5}[0-9]{17}$/;
  const regexUAN = /^\d{4,12}$/;
  const regexName = /^[a-zA-Z\s]+$/;
  const regexName1 = /^[A-Za-z]+$/;
  const regexContact = /^[0-9]+$/;
  const [error, seterror] = useState({
    mother: { motherName: false },
    father: { fatherName: false },
    secondaryEmail: false,
    altPhoneNumber: false,
    passport: false,
    pf: false,
    uan: false,
    ESIC: false,
    currentAddress: { postalCode: false },
    permanentAddress: { postalCode: false },
    spouse: false,
    isFresher: false,
    religion: false,
  });
  const [profileError, setProfileError] = useState("");
  const [signatureFileNameError, setSignatureFileNameError] = useState("");

  const [nameError, setNameError] = useState(
    Array.from(user.emergencyContact, (e, i) => {
      return { name: "" };
    }),
  );

  const [contactError, setContactError] = useState(
    Array.from(user.emergencyContact, (e, i) => {
      return { contact: "" };
    }),
  );

  const [familyNameError, setFamilyNameError] = useState(
    Array.from(user.familyDetails, (e, i) => {
      return { name: "" };
    }),
  );

  const [familyContactError, setFamilyContactError] = useState(
    Array.from(user.familyDetails, (e, i) => {
      return { contact: "" };
    }),
  );

  const reduxUser = useSelector(selectUser);
  const { loadDraft, saveDraft, deleteDraft, saving: draftSaving, lastDraftedAt } = useDraft(
    "newJoinee",
    "A",
  );



  const totalExpInYr = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    "20+",
  ];
  const totalExpInMonth = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

  const mapUserToSectionAState = (rawUser) => {
    const raw = rawUser || {};
    return {
      _id: raw._id || "",
      name: raw.name ? raw.name : "",
      email: raw.email ? raw.email : "",
      designation: raw.designation ? raw.designation : "",
      doj: raw.doj ? raw.doj : "",
      workLocation: raw.workLocation ? raw.workLocation : "",
      aadhaar: raw.aadhaar ? raw.aadhaar : "",
      pan: raw.pan ? raw.pan : "",
      phoneNumber: raw.phoneNumber ? raw.phoneNumber : "",
      companyName: raw.companyName ? raw.companyName : "",
      altPhoneNumber: raw.altPhoneNumber ? raw.altPhoneNumber : "",
      permanentAddressSame: raw.permanentAddressSame ? raw.permanentAddressSame : false,
      secondaryEmail: raw.secondaryEmail ? raw.secondaryEmail : "",
      mother: raw.mother ? raw.mother : { name: "", occupation: "" },
      father: raw.father ? raw.father : { name: "", occupation: "" },
      gender: raw.gender ? raw.gender : "",
      dateOfBirth: raw.dateOfBirth ? raw.dateOfBirth : "",
      bloodGroup: raw.bloodGroup ? raw.bloodGroup : "",
      maritalStatus: raw.maritalStatus ? raw.maritalStatus : "",
      spouse: raw.spouse ? raw.spouse : "",
      isPassport: raw.isPassport ? raw.isPassport : "",
      passport: raw.passport ? raw.passport : "",
      passportExpiry: raw.passportExpiry ? raw.passportExpiry : "",
      linkedIn: raw.linkedIn ? raw.linkedIn : "",
      pf: raw.pf ? raw.pf : "",
      uan: raw.uan ? raw.uan : "",
      ESIC: raw.ESIC ? raw.ESIC : "",
      skills: Array.isArray(raw.skills) ? raw.skills : [],
      currentAddress: raw.currentAddress
        ? raw.currentAddress
        : {
            addressLine1: "",
            addressLine2: "",
            addressLine3: "",
            landmark: "",
            postalCode: "",
            periodOfStay: "",
            natureOfResidency: "",
          },
      permanentAddress: raw.permanentAddress
        ? raw.permanentAddress
        : {
            addressLine1: "",
            addressLine2: "",
            addressLine3: "",
            landmark: "",
            postalCode: "",
            periodOfStay: "",
            natureOfResidency: "",
          },
      familyDetails:
        raw.familyDetails && raw.familyDetails.length > 0
          ? raw.familyDetails
          : [
              { name: "", contact: "", relationship: "" },
              { name: "", contact: "", relationship: "" },
            ],
      emergencyContact:
        raw.emergencyContact && raw.emergencyContact.length > 0
          ? raw.emergencyContact
          : [
              { name: "", contact: "", relationship: "" },
              { name: "", contact: "", relationship: "" },
            ],
      isSodexo: raw.isSodexo ? raw.isSodexo : false,
      sodexoCouponValue: raw.sodexoCouponValue ? raw.sodexoCouponValue : "",
      totalExperienceInYears: raw.totalExperienceInYears ? raw.totalExperienceInYears : "",
      totalExperienceInMonths: raw.totalExperienceInMonths ? raw.totalExperienceInMonths : "",
      relevantExperienceInYears: raw.relevantExperienceInYears ? raw.relevantExperienceInYears : "",
      relevantExperienceInMonths: raw.relevantExperienceInMonths ? raw.relevantExperienceInMonths : "",
      isFresher: raw.isFresher ? true : false,
      religion: raw.religion ? raw.religion : "",
      profilePhoto: raw.profilePhoto ? raw.profilePhoto : "",
      profilePhoto_fileName: raw.profilePhoto_fileName ? raw.profilePhoto_fileName : "",
      signature: raw.signature ? raw.signature : "",
      signature_fileName: raw.signature_fileName ? raw.signature_fileName : "",
    };
  };

  useEffect(() => {
    let isActive = true;

    (async () => {
      if (!reduxUser.user.isAdmin) {
        const loadedDraft = await loadDraft();
        const draftData = loadedDraft && loadedDraft.data ? loadedDraft.data : null;
        if (isActive && draftData && typeof draftData === "object") {
          const applied = applySectionDraftData("newJoinee", "A", initialState, draftData);
          const mapped = mapUserToSectionAState(applied);
          setUser(mapped);
          mapped.signature_fileName ? setSign(true) : setSign(false);
          setFileName(mapped.signature_fileName || null);
          setProfileFileName(mapped.profilePhoto_fileName || null);
          return;
        }
      }

      UserAPI.getUser(reduxUser.user.isAdmin ? id : reduxUser.user._id)
        .then((res) => {
          if (!isActive) return;
        const obj = mapUserToSectionAState(res.data);
        obj.signature_fileName ? setSign(true) : setSign(false);
        setFileName(obj.signature_fileName || null);
        setProfileFileName(obj.profilePhoto_fileName || null);

        setApprovedComment(
          res.data.newJoineeFormComment
            ? res.data.internal_notes.newJoineeFormComment
            : "",
        );
        setReSubmitComment(
          res.data.newJoineeFormComment ? res.data.newJoineeFormComment : "",
        );
        setNewJoineeSectionAFlagButton(
          res.data ? res.data.isNewJoineeFormComplete : "",
        );
        setNewJoineeFlagButton(
          res.data ? res.data.isNewJoineeFormComplete : "",
        );
        setUser({ ...obj });
        document.getElementById("profilePicture").src = obj.profilePhoto;
        })
        .catch((err) => {
          console.log(err);
        });
    })();

    return () => {
      isActive = false;
    };
  }, [id, loadDraft, reduxUser.user._id, reduxUser.user.isAdmin]);

  const handleSaveDraft = async () => {
    if (reduxUser.user.isAdmin) return;

    const sectionState = {
      ...user,
      profilePhoto_fileName: profileFileName || user.profilePhoto_fileName || "",
      signature_fileName: fileName ? fileName : user.signature_fileName,
    };

    const wrapped = pickSectionDraftData("newJoinee", "A", sectionState);
    const saved = await saveDraft(wrapped);
    if (saved && saved.skipped) {
      toast.info("Nothing to save as draft");
      return;
    }
    if (saved) {
      toast.success("Draft saved");
      if (sectionState.isFresher) changeTab(1);
    } else {
      toast.error("Unable to save draft");
    }
  };

  const [validateerror, setvalidateerror] = useState();

  const getRequiredValidationResult = () => {
    const arr = [
      user.mother.name,
      user.mother.occupation,
      user.father.name,
      user.father.occupation,
      user.gender,
      user.maritalStatus,
      user.religion,
      user.skills,
      user.currentAddress.addressLine1,
      user.currentAddress.addressLine2,
      user.currentAddress.addressLine3,
      user.currentAddress.postalCode,
      user.familyDetails.map((e) => e.name),
      user.familyDetails.map((e) => e.contact),
      user.familyDetails.map((e) => e.relationship),
      user.emergencyContact.map((e) => e.name),
      user.emergencyContact.map((e) => e.contact),
      user.emergencyContact.map((e) => e.relationship),
      user.currentAddress.periodOfStay,
      user.currentAddress.natureOfResidency,
      user.permanentAddress.addressLine1,
      user.permanentAddress.addressLine2,
      user.permanentAddress.addressLine3,
      user.permanentAddress.postalCode,
      user.dateOfBirth,
      user.permanentAddress.periodOfStay,
      user.permanentAddress.natureOfResidency,
    ];
    var arrName = [
      "mother",
      "motherOccupation",
      "father",
      "fatherOccupation",
      "gender",
      "maritalStatus",
      "religion",
      "skills",
      "currentAddressaddressLine1",
      "currentAddressaddressLine2",
      "currentAddressaddressLine3",
      "currentAddresspostalCode",
      Array.from(user.familyDetails, (e, i) => `familyDetailsname${i}`),
      Array.from(user.familyDetails, (e, i) => `familyDetailscontact${i}`),
      Array.from(user.familyDetails, (e, i) => `familyDetailsrelationship${i}`),
      Array.from(user.emergencyContact, (e, i) => `emergencyContactname${i}`),
      Array.from(
        user.emergencyContact,
        (e, i) => `emergencyContactcontact${i}`,
      ),
      Array.from(user.emergencyContact, (e, i) => `emergencyContactreln${i}`),
      "currentPeriodOfStay",
      "currentNatureOfResidency",
      "permanentAddressaddressLine1",
      "permanentAddressaddressLine2",
      "permanentAddressaddressLine3",
      "permanentAddresspostalCode",
      "dateOfBirth",
      "permanentPeriodOfStay",
      "permanentNatureOfResidency",
    ];
    const keyObj = [];
    for (let i = 0; i < arr.length; i++) {
      if (i === 12 || i === 13 || i === 14 || i === 15 || i === 16 || i == 17) {
        let fmDetail = [];
        for (let j in arr[i]) {
          if (!arr[i][j]) {
            fmDetail.push({
              name: arrName[i][j],
              status: true,
            });
          } else {
            fmDetail.push({
              name: arrName[i][j],
              status: false,
            });
          }
        }
        keyObj.push(fmDetail);
      } else {
        if (!arr[i]) {
          keyObj.push({
            name: arrName[i],
            status: true,
          });
        } else {
          keyObj.push({
            name: arrName[i],
            status: false,
          });
        }
      }
    }

    const check = arr.every((e) => {
      if (typeof e === "object") {
        return e.every((x) => x);
      } else {
        return e;
      }
    });
    return { check, keyObj };
  };

  const convertToCamelCase = (input) => {
    if (input === null || input.length === 0) {
      return input;
    }
    const words = input.split(" ");
    const camelCaseWords = words.map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });

    return camelCaseWords.join(" ");
  };

  const handleSecondDaryEmailChange = (e) => {
    const { value } = e.target;
    if (!regexEmail.test(value)) {
      seterror({ ...error, secondaryEmail: true });
    } else {
      seterror({ ...error, secondaryEmail: false });
    }
    setUser({ ...user, secondaryEmail: value });
  };

  const handleAlternateNumberChange = (e) => {
    const { value } = e.target;
    if (value.length !== 10) {
      seterror({ ...error, altPhoneNumber: true });
    } else {
      seterror({ ...error, altPhoneNumber: false });
    }
    setUser({ ...user, altPhoneNumber: value });
  };

  const handleFamilyChange = (e, relation, field) => {
    const { value } = e.target;
    const camelCaseValue = convertToCamelCase(value);
    let obj = {
      name: field == "name" ? camelCaseValue : user[relation].name,
      occupation:
        field == "occupation" ? camelCaseValue : user[relation].occupation,
    };

    let errorDestr = { ...error };
    if (field == "name" && !value.trim()) {
      errorDestr.mother.motherName = true;
    } else {
      errorDestr.mother.motherName = false;
    }
    seterror(errorDestr);

    if (field === "name" && camelCaseValue === "") {
      setUser({ ...user, [relation]: obj });
    } else if (field === "occupation" && camelCaseValue === "") {
      setUser({ ...user, [relation]: obj });
    } else if (field === "name" && regexName.test(e.target.value)) {
      setUser({ ...user, [relation]: obj });
    } else if (field === "occupation" && regexName.test(e.target.value)) {
      setUser({ ...user, [relation]: obj });
    }

    if (Array.isArray(validateerror)) {
      const validateChange = [...validateerror];
      if (field === "name" && validateChange[0]) {
        validateChange[0].status = false;
      }
      if (field === "occupation" && validateChange[1]) {
        validateChange[1].status = false;
      }
      setvalidateerror(validateChange);
    }
  };

  const handleFamilyChange2 = (e, relation, field) => {
    const { value } = e.target;
    const camelCaseValue = convertToCamelCase(value);
    let obj = {
      name: field == "name" ? camelCaseValue : user[relation].name,
      occupation:
        field == "occupation" ? camelCaseValue : user[relation].occupation,
    };

    let errorDestr = { ...error };
    if (field == "name" && !value.trim()) {
      errorDestr.father.fatherName = true;
    } else {
      errorDestr.father.fatherName = false;
    }
    seterror(errorDestr);

    if (field === "name" && camelCaseValue === "") {
      setUser({ ...user, [relation]: obj });
    } else if (field === "occupation" && camelCaseValue === "") {
      setUser({ ...user, [relation]: obj });
    } else if (field === "name" && regexName.test(camelCaseValue)) {
      setUser({ ...user, [relation]: obj });
    } else if (field === "occupation" && regexName.test(camelCaseValue)) {
      setUser({ ...user, [relation]: obj });
    }

    if (Array.isArray(validateerror)) {
      const validateChange = [...validateerror];
      if (field === "name" && validateChange[2]) {
        validateChange[2].status = false;
      }
      if (field === "occupation" && validateChange[3]) {
        validateChange[3].status = false;
      }
      setvalidateerror(validateChange);
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const handleGender = (e) => {
    const { value } = e.target;
    setUser({ ...user, gender: value });
    if (validateerror) {
      const validateGender = [...validateerror];
      validateGender[4].status = false;
      setvalidateerror(validateGender);
    }
  };

  const handleDateOfBirth = (e) => {
    let tempdate = { ...user };

    let date = "";
    if (e) {
      let m = e.$d.getMonth() + 1;
      m = m < 10 ? `0${m}` : m;
      let d = ("0" + e.$D).slice(-2);
      date = e.$d.getFullYear() + "-" + m + "-" + d;

      tempdate.dateOfBirth = date;

      setUser(tempdate);
    }

    if (validateerror) {
      const validateDateOfBirth = [...validateerror];
      validateDateOfBirth[24].status = false;
      setvalidateerror(validateDateOfBirth);
    }
  };

  const handleBloodGroup = (e) => {
    const { value } = e.target;
    setUser({ ...user, bloodGroup: value });
  };

  const handleReligion = (e) => {
    const { value } = e.target;
    const camelCaseValue = convertToCamelCase(value);

    let errorDestr = { ...error };
    if (!value.trim()) {
      errorDestr.religion = true;
    } else {
      errorDestr.religion = false;
    }
    seterror(errorDestr);

    if (camelCaseValue === "") {
      setUser({ ...user, religion: camelCaseValue });
    }
    if (regexName.test(e.target.value)) {
      setUser({ ...user, religion: camelCaseValue });
    }

    if (validateerror) {
      const validateReligion = [...validateerror];
      validateReligion[6].status = false;
      setvalidateerror(validateReligion);
    }
  };

  const handleMaritalStatus = (e) => {
    const value = e.target.value;
    setUser({ ...user, maritalStatus: value });

    if (validateerror) {
      const validateMaritalStatus = [...validateerror];
      validateMaritalStatus[5].status = false;
      setvalidateerror(validateMaritalStatus);
    }
  };

  const handleSpouseChange = (e) => {
    const { value } = e.target;
    const camelCaseValue = convertToCamelCase(value);
    if (!value.trim()) {
      seterror({ ...error, spouse: true });
    } else {
      seterror({ ...error, spouse: false });
    }
    if (camelCaseValue === "") {
      setUser({ ...user, spouse: value });
    }
    if (regexName.test(camelCaseValue)) {
      setUser({ ...user, spouse: camelCaseValue });
    }
  };

  const handleTotalExperienceInYears = (e) => {
    const value = e.target.value;
    setUser({ ...user, totalExperienceInYears: value });
  };

  const handleRelavantExperienceInYears = (e) => {
    const value = e.target.value;
    setUser({ ...user, relevantExperienceInYears: value });
  };

  const handleTotalExperienceInMonths = (e) => {
    const value = e.target.value;
    setUser({ ...user, totalExperienceInMonths: value });
  };

  const handleRelavantExperienceInMonths = (e) => {
    const value = e.target.value;
    setUser({ ...user, relevantExperienceInMonths: value });
  };

  const handlePassportStatus = (e) => {
    const value = e.target.value;
    setUser({ ...user, isPassport: value });
  };

  const handlePassportInput = (e) => {
    const { value } = e.target;
    const passportValue = value.toUpperCase();
    if (!regexPassport.test(passportValue)) {
      seterror({ ...error, passport: true });
    } else {
      seterror({ ...error, passport: false });
    }
    setUser({ ...user, passport: passportValue });
  };

  const handlePassportExpiryDate = (e) => {
    let tempdate = { ...user };

    let date = "";
    if (e) {
      let m = e.$d.getMonth() + 1;
      m = m < 10 ? `0${m}` : m;
      let d = ("0" + e.$D).slice(-2);
      date = e.$d.getFullYear() + "-" + m + "-" + d;

      tempdate.passportExpiry = date;

      setUser(tempdate);
    }
  };

  const handleLinkedIn = (e) => {
    const { value } = e.target;
    setUser({ ...user, linkedIn: value });
  };

  const handlePF = (e) => {
    const { value } = e.target;
    seterror({ ...error, pf: false });
    setUser({ ...user, pf: value });
  };

  const handleUAN = (e) => {
    const { value } = e.target;
    if (!regexUAN.test(value)) {
      seterror({ ...error, uan: true });
    } else {
      seterror({ ...error, uan: false });
    }
    setUser({ ...user, uan: value });
  };

  const handleESIC = (e) => {
    const { value } = e.target;
    if (value.length < 10) {
      seterror({ ...error, ESIC: true });
    } else {
      seterror({ ...error, ESIC: false });
    }
    if (value.length <= 10) {
      setUser({ ...user, ESIC: value });
    }
  };

  const handleAddressSame = (e) => {
    const { checked } = e.target;
    const userData = { ...user };
    if (checked) {
      userData.permanentAddress.addressLine1 =
        userData.currentAddress.addressLine1;
      userData.permanentAddress.addressLine2 =
        userData.currentAddress.addressLine2;
      userData.permanentAddress.addressLine3 =
        userData.currentAddress.addressLine3;
      userData.permanentAddress.landmark = userData.currentAddress.landmark;
      userData.permanentAddress.postalCode = userData.currentAddress.postalCode;
      userData.permanentAddress.periodOfStay = userData.currentAddress.periodOfStay;
      userData.permanentAddress.natureOfResidency = userData.currentAddress.natureOfResidency;
    } else {
      userData.permanentAddress.addressLine1 = "";
      userData.permanentAddress.addressLine2 = "";
      userData.permanentAddress.addressLine3 = "";
      userData.permanentAddress.landmark = "";
      userData.permanentAddress.postalCode = "";
      userData.permanentAddress.periodOfStay = "";
      userData.permanentAddress.natureOfResidency = "";
    }
    userData.permanentAddressSame = checked;
    setUser(userData);

    if (validateerror) {
      const validateAddress = [...validateerror];
      validateAddress[20].status = false;
      validateAddress[21].status = false;
      validateAddress[22].status = false;
      validateAddress[23].status = false;
      validateAddress[25].status = false;
      validateAddress[26].status = false;
      setvalidateerror(validateAddress);
    }
  };

  const handleFresherChecked = (e) => {
    const { checked } = e.target;
    setUser({ ...user, isFresher: checked });
    seterror({ ...error, isFresher: false });
  };

  const handleSodexoChecked = (e) => {
    const { checked } = e.target;
    const userChecked = { ...user };
    userChecked.isSodexo = checked;
    setUser(userChecked);
  };

  const handleSodexoChange = (e) => {
    const { value } = e.target;
    setUser({ ...user, sodexoCouponValue: value });
  };

  const handleAddressChange = (e, type, field) => {
    const { value } = e.target;
    let obj = {
      addressLine1: field == "1" ? value : user[type].addressLine1,
      addressLine2: field == "2" ? value : user[type].addressLine2,
      addressLine3: field == "3" ? value : user[type].addressLine3,
      landmark: field == "4" ? value : user[type].landmark,
      postalCode: field == "5" ? value : user[type].postalCode,
      periodOfStay: field == "6" ? value : user[type].periodOfStay,
      natureOfResidency: field == "7" ? value : user[type].natureOfResidency,
    };
    let errorDestrc = { ...error };
    if (field == "5" && type === "currentAddress" && value.length !== 6) {
      errorDestrc.currentAddress.postalCode = true;
    } else {
      errorDestrc.currentAddress.postalCode = false;
    }
    if (field == "5" && type === "permanentAddress" && value.length !== 6) {
      errorDestrc.permanentAddress.postalCode = true;
    } else {
      errorDestrc.permanentAddress.postalCode = false;
    }
    seterror(errorDestrc);
    setUser({ ...user, [type]: obj });

    if (validateerror) {
      const validateAddress = [...validateerror];
      validateAddress[8].status = false;
      validateAddress[9].status = false;
      validateAddress[10].status = false;
      validateAddress[11].status = false;
      validateAddress[18].status = false;
      validateAddress[19].status = false;
      validateAddress[20].status = false;
      validateAddress[21].status = false;
      validateAddress[22].status = false;
      validateAddress[23].status = false;
      validateAddress[25].status = false;
      validateAddress[26].status = false;
      setvalidateerror(validateAddress);
    }
  };

  const handleAddFamily = () => {
    let tempFamily = [...user.familyDetails];
    tempFamily.push({
      name: "",
      contact: "",
      relationship: "",
    });

    setUser({ ...user, familyDetails: tempFamily });

    setFamilyNameError([...familyNameError, { name: "" }]);
    setFamilyContactError([...familyContactError, { contact: "" }]);
  };

  const handleDeleteFamily = (index) => {
    let tempFamily = [...user.familyDetails];
    tempFamily.splice(index, 1);
    setUser({ ...user, familyDetails: tempFamily });

    const familyErrorDel = [...familyNameError];
    familyErrorDel.splice(index, 1);
    setFamilyNameError(familyErrorDel);

    const familyErrorDel2 = [...familyContactError];
    familyErrorDel2.splice(index, 1);
    setFamilyContactError(familyErrorDel2);
  };

  const handleFamily = (e, index, type) => {
    const { value } = e.target;
    const camelCaseValue = convertToCamelCase(value);
    let tempFamily = [...user.familyDetails];

    if (type === "name" && camelCaseValue === "") {
      tempFamily[index][type] = camelCaseValue;
      setUser({ ...user, familyDetails: tempFamily });
    } else if (type === "contact" && camelCaseValue === "") {
      tempFamily[index][type] = camelCaseValue;
      setUser({ ...user, familyDetails: tempFamily });
    } else if (type === "name" && regexName.test(value)) {
      tempFamily[index][type] = camelCaseValue;
      setUser({ ...user, familyDetails: tempFamily });
    } else if (
      type === "contact" &&
      value.length <= 10 &&
      regexContact.test(value)
    ) {
      tempFamily[index][type] = camelCaseValue;
      setUser({ ...user, familyDetails: tempFamily });
    } else if (type === "relationship") {
      tempFamily[index][type] = value;
      setUser({ ...user, familyDetails: tempFamily });
    }

    let errorDestrc = [...familyNameError];
    if (type === "name") {
      if (!value.trim()) {
        errorDestrc[index][type] = errorDestrc[index] && true;
      } else {
        errorDestrc[index][type] = errorDestrc[index] && false;
      }
      setFamilyNameError(errorDestrc);
    }
    let errorDestrc2 = [...familyContactError];

    if (type === "contact") {
      if (value.length !== 10) {
        errorDestrc2[index][type] = errorDestrc2[index] && true;
      } else {
        errorDestrc2[index][type] = errorDestrc2[index] && false;
      }
      setFamilyContactError(errorDestrc2);
    }
  };

  const handleContact = (e, index, type) => {
    const { value } = e.target;
    const camelCaseValue = convertToCamelCase(value);
    let tempContact = [...user.emergencyContact];

    if (type === "name" && camelCaseValue === "") {
      tempContact[index][type] = camelCaseValue;
      setUser({ ...user, emergencyContact: tempContact });
    } else if (type === "contact" && camelCaseValue === "") {
      tempContact[index][type] = camelCaseValue;
      setUser({ ...user, emergencyContact: tempContact });
    } else if (type === "relationship" && camelCaseValue === "") {
      tempContact[index][type] = camelCaseValue;
      setUser({ ...user, emergencyContact: tempContact });
    } else if (type === "name" && regexName.test(camelCaseValue)) {
      tempContact[index][type] = camelCaseValue;
      setUser({ ...user, emergencyContact: tempContact });
    } else if (
      type === "contact" &&
      value.length <= 10 &&
      regexContact.test(camelCaseValue)
    ) {
      tempContact[index][type] = camelCaseValue;
      setUser({ ...user, emergencyContact: tempContact });
    } else if (type === "relationship") {
      tempContact[index][type] = value;
      setUser({ ...user, emergencyContact: tempContact });
    }

    let errorDestrc2 = [...nameError];
    if (type === "name" && !value.trim()) {
      errorDestrc2[index][type] = true;
    } else {
      errorDestrc2[index][type] = false;
    }
    setNameError(errorDestrc2);

    let errorDestrc = [...contactError];
    if (type === "contact" && value.length !== 10) {
      errorDestrc[index][type] = true;
    } else {
      errorDestrc[index][type] = false;
    }
    setContactError(errorDestrc);
  };

  const handleResetAll = () => {
    const resetFields = {
      emergencyContact: [
        { name: "", contact: "", relationship: "" },
        { name: "", contact: "", relationship: "" },
      ],
      familyDetails: [
        { name: "", contact: "", relationship: "" },
        { name: "", contact: "", relationship: "" },
      ],
      secondaryEmail: "",
      mother: { name: "", occupation: "" },
      father: { name: "", occupation: "" },
      gender: "",
      dateOfBirth: null,
      bloodGroup: "",
      maritalStatus: false,
      spouse: "",
      isPassport: false,
      passport: "",
      passportExpiry: null,
      linkedIn: "",
      pf: "",
      uan: "",
      skills: [],
      currentAddress: {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        landmark: "",
        postalCode: "",
        periodOfStay: "",
        natureOfResidency: "",
      },
      permanentAddress: {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        landmark: "",
        postalCode: "",
        periodOfStay: "",
        natureOfResidency: "",
      },
      permanentAddressSame: false,
      isSodexo: false,
      sodexoCouponValue: "",
      totalExperienceInYears: "",
      totalExperienceInMonths: "",
      relevantExperienceInYears: "",
      relevantExperienceInMonths: "",
      altPhoneNumber: "",
      isFresher: false,
      religion: "",
      profilePhoto: "",
      profilePhoto_fileName: "",
      signature: "",
      signature_fileName: "",
      ESIC: "",
    };
    setUser((prev) => ({
      ...prev,
      ...resetFields,
    }));
    setSign(false);
    setProfileFileName(null);
    setFileName(null);
  };

  const handleImageUpload = (event, value) => {
    const file = event.target.files[0];
    if (!file) return;
    const profilemaxSizeInBytes = 1000 * 1024;
    const signaturemaxSizeInBytes = 500 * 1024;
    if (value === 1 && file.size > profilemaxSizeInBytes) {
      toast.error("File size exceeds the 1000 KB limit", {
        hideProgressBar: true,
        closeOnClick: true,
      });
      return;
    }
    if (value === 2 && file.size > signaturemaxSizeInBytes) {
      toast.error("File size exceeds the 500 KB limit", {
        hideProgressBar: true,
        closeOnClick: true,
      });
      return;
    }
    if (value === 1) {
      setProfileFileName(file.name);
    } else if (value === 2) {
      setFileName(file.name);
    }
    const reader = new FileReader();
    reader.onload = (event) => {
      const imageDataURL = event.target.result;

      if (value === 1) {
        setUser((prev) => ({
          ...prev,
          profilePhoto: imageDataURL,
          profilePhoto_fileName: file.name,
        }));
        document.getElementById("profilePicture").src = imageDataURL;
      } else if (value === 2) {
        setUser((prev) => ({
          ...prev,
          signature: imageDataURL,
          signature_fileName: file.name,
        }));
      }
    };
    if (value === 1) {
      setImage(true);
    } else if (value === 2) {
      setSign(true);
    }

    reader.readAsDataURL(file);
    setLoadingButton(false);
    setProfileError(false);
    setSignatureFileNameError(false);
  };

  const handleSign = () => {
    setUser({ ...user, signature_fileName: "", signature: "" });
    setFileName(null);
    setSign(false);
  };

  const sectionAErrorSelector =
    '[aria-invalid="true"], .Mui-error, [data-section-a-error="true"]';

  const isVisibleElement = (element) =>
    element &&
    (element.offsetWidth || element.offsetHeight || element.getClientRects().length);

  const scrollToSectionAError = (selector = sectionAErrorSelector) => {
    setTimeout(() => {
      let candidates = Array.from(document.querySelectorAll(selector));
      let target = candidates.find(isVisibleElement);

      if (!target && selector !== sectionAErrorSelector) {
        candidates = Array.from(document.querySelectorAll(sectionAErrorSelector));
        target = candidates.find(isVisibleElement);
      }

      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "center" });
        const focusTarget = target.matches(
          'input, textarea, button, [role="button"], [role="combobox"]',
        )
          ? target
          : target.querySelector(
              'input, textarea, button, [role="button"], [role="combobox"]',
            );
        if (focusTarget && typeof focusTarget.focus === "function") {
          focusTarget.focus({ preventScroll: true });
        }
      }
    }, 0);
  };

  const getStringValue = (value) =>
    value === null || value === undefined ? "" : String(value);

  const getFirstSectionAErrorSelector = (
    requiredErrors,
    sectionError,
    familyContactErrors,
    emergencyContactErrors,
    missingProfile,
    missingSignature,
    missingAck,
  ) => {
    const requiredAt = (index) =>
      Boolean(requiredErrors && requiredErrors[index] && requiredErrors[index].status);
    const requiredArrayAt = (index, itemIndex) =>
      Boolean(
        requiredErrors &&
          requiredErrors[index] &&
          requiredErrors[index][itemIndex] &&
          requiredErrors[index][itemIndex].status,
      );

    const checks = [
      { selector: "#sectionA-profile-upload", invalid: missingProfile },
      { selector: "#sectionA-signature-upload", invalid: missingSignature },
      { selector: "#sectionA-secondary-email", invalid: sectionError.secondaryEmail },
      { selector: "#sectionA-alt-phone", invalid: sectionError.altPhoneNumber },
      {
        selector: "#sectionA-mother-name",
        invalid: requiredAt(0) || sectionError.mother.motherName,
      },
      { selector: "#sectionA-mother-occupation", invalid: requiredAt(1) },
      {
        selector: "#sectionA-father-name",
        invalid: requiredAt(2) || sectionError.father.fatherName,
      },
      { selector: "#sectionA-father-occupation", invalid: requiredAt(3) },
      { selector: "#sectionA-gender-group", invalid: requiredAt(4) },
      { selector: "#sectionA-dob", invalid: requiredAt(24) },
      { selector: "#sectionA-religion", invalid: requiredAt(6) || sectionError.religion },
      { selector: "#sectionA-marital-status-group", invalid: requiredAt(5) },
      { selector: "#sectionA-spouse", invalid: sectionError.spouse },
      { selector: "#sectionA-experience-group", invalid: sectionError.isFresher },
      { selector: "#sectionA-passport-number", invalid: sectionError.passport },
      { selector: "#sectionA-pf", invalid: sectionError.pf },
      { selector: "#sectionA-uan", invalid: sectionError.uan },
      { selector: "#sectionA-esic", invalid: sectionError.ESIC },
      { selector: "#sectionA-skills", invalid: requiredAt(7) },
      {
        selector: "#sectionA-current-address-line1",
        invalid: requiredAt(8),
      },
      {
        selector: "#sectionA-current-address-line2",
        invalid: requiredAt(9),
      },
      {
        selector: "#sectionA-current-address-line3",
        invalid: requiredAt(10),
      },
      {
        selector: "#sectionA-current-postal-code",
        invalid: requiredAt(11) || sectionError.currentAddress.postalCode,
      },
      {
        selector: "#sectionA-current-period",
        invalid: requiredAt(18),
      },
      {
        selector: "#sectionA-current-residency",
        invalid: requiredAt(19),
      },
      {
        selector: "#sectionA-permanent-address-line1",
        invalid: requiredAt(20),
      },
      {
        selector: "#sectionA-permanent-address-line2",
        invalid: requiredAt(21),
      },
      {
        selector: "#sectionA-permanent-address-line3",
        invalid: requiredAt(22),
      },
      {
        selector: "#sectionA-permanent-postal-code",
        invalid: requiredAt(23) || sectionError.permanentAddress.postalCode,
      },
      {
        selector: "#sectionA-permanent-period",
        invalid: requiredAt(25),
      },
      {
        selector: "#sectionA-permanent-residency",
        invalid: requiredAt(26),
      },
    ];

    user.familyDetails.forEach((_, index) => {
      checks.push(
        {
          selector: `#sectionA-family-name-${index}`,
          invalid: requiredArrayAt(12, index),
        },
        {
          selector: `#sectionA-family-contact-${index}`,
          invalid:
            requiredArrayAt(13, index) ||
            Boolean(familyContactErrors[index] && familyContactErrors[index].contact),
        },
        {
          selector: `#sectionA-family-relationship-${index}`,
          invalid: requiredArrayAt(14, index),
        },
      );
    });

    user.emergencyContact.forEach((_, index) => {
      checks.push(
        {
          selector: `#sectionA-emergency-name-${index}`,
          invalid: requiredArrayAt(15, index),
        },
        {
          selector: `#sectionA-emergency-contact-${index}`,
          invalid:
            requiredArrayAt(16, index) ||
            Boolean(emergencyContactErrors[index] && emergencyContactErrors[index].contact),
        },
        {
          selector: `#sectionA-emergency-relationship-${index}`,
          invalid: requiredArrayAt(17, index),
        },
      );
    });

    checks.push({ selector: "#sectionA-acknowledgement", invalid: missingAck });
    const firstError = checks.find((item) => item.invalid);
    return firstError ? firstError.selector : "";
  };

  const buildSectionAValidation = () => {
    const { check, keyObj } = getRequiredValidationResult();
    const valueOf = getStringValue;
    const passportValue = valueOf(user.passport).toUpperCase();
    const currentPostalCode = valueOf(user.currentAddress.postalCode);
    const permanentPostalCode = user.permanentAddressSame
      ? valueOf(user.currentAddress.postalCode)
      : valueOf(user.permanentAddress.postalCode);

    const sectionError = {
      mother: { motherName: !valueOf(user.mother.name).trim() },
      father: { fatherName: !valueOf(user.father.name).trim() },
      secondaryEmail:
        Boolean(valueOf(user.secondaryEmail)) && !regexEmail.test(valueOf(user.secondaryEmail)),
      altPhoneNumber:
        Boolean(valueOf(user.altPhoneNumber)) && valueOf(user.altPhoneNumber).length !== 10,
      passport: user.isPassport === "true" && !regexPassport.test(passportValue),
      pf: Boolean(valueOf(user.pf)) && !regexPF.test(valueOf(user.pf)),
      uan: Boolean(valueOf(user.uan)) && !regexUAN.test(valueOf(user.uan)),
      ESIC: Boolean(valueOf(user.ESIC)) && valueOf(user.ESIC).length < 10,
      currentAddress: {
        postalCode:
          Boolean(currentPostalCode) && currentPostalCode.length !== 6,
      },
      permanentAddress: {
        postalCode:
          Boolean(permanentPostalCode) && permanentPostalCode.length !== 6,
      },
      spouse:
        user.maritalStatus === "married" &&
        (!valueOf(user.spouse).trim() || !regexName.test(valueOf(user.spouse))),
      isFresher:
        user.isFresher === true &&
        (user.totalExperienceInYears === "" ||
          user.totalExperienceInMonths === "" ||
          user.relevantExperienceInYears === "" ||
          user.relevantExperienceInMonths === ""),
      religion: !valueOf(user.religion).trim() || !regexName.test(valueOf(user.religion)),
    };

    const familyNameErrors = user.familyDetails.map((item) => ({
      name: Boolean(valueOf(item.name)) && !regexName.test(valueOf(item.name)),
    }));
    const familyContactErrors = user.familyDetails.map((item) => ({
      contact: Boolean(valueOf(item.contact)) && valueOf(item.contact).length !== 10,
    }));
    const emergencyNameErrors = user.emergencyContact.map((item) => ({
      name: Boolean(valueOf(item.name)) && !regexName.test(valueOf(item.name)),
    }));
    const emergencyContactErrors = user.emergencyContact.map((item) => ({
      contact: Boolean(valueOf(item.contact)) && valueOf(item.contact).length !== 10,
    }));
    const missingProfile = !user.profilePhoto;
    const missingSignature = !user.signature;
    const missingAck = !reduxUser.user.isAdmin && !ackChecked;
    const hasSectionError =
      sectionError.mother.motherName ||
      sectionError.father.fatherName ||
      sectionError.secondaryEmail ||
      sectionError.altPhoneNumber ||
      sectionError.passport ||
      sectionError.pf ||
      sectionError.uan ||
      sectionError.ESIC ||
      sectionError.currentAddress.postalCode ||
      sectionError.permanentAddress.postalCode ||
      sectionError.spouse ||
      sectionError.isFresher ||
      sectionError.religion ||
      familyNameErrors.some((item) => item.name) ||
      familyContactErrors.some((item) => item.contact) ||
      emergencyNameErrors.some((item) => item.name) ||
      emergencyContactErrors.some((item) => item.contact);

    const firstSelector = getFirstSectionAErrorSelector(
      keyObj,
      sectionError,
      familyContactErrors,
      emergencyContactErrors,
      missingProfile,
      missingSignature,
      missingAck,
    );

    return {
      check,
      keyObj,
      sectionError,
      familyNameErrors,
      familyContactErrors,
      emergencyNameErrors,
      emergencyContactErrors,
      missingProfile,
      missingSignature,
      missingAck,
      firstSelector,
      normalizedPassport: passportValue,
      valid:
        check &&
        !hasSectionError &&
        !missingProfile &&
        !missingSignature &&
        !missingAck,
    };
  };

  const handleSubmit = () => {
    const validation = buildSectionAValidation();
    const fieldFirstSelector = getFirstSectionAErrorSelector(
      validation.keyObj,
      validation.sectionError,
      validation.familyContactErrors,
      validation.emergencyContactErrors,
      validation.missingProfile,
      validation.missingSignature,
      false,
    );
    setvalidateerror(validation.keyObj);
    seterror(validation.sectionError);
    setFamilyNameError(validation.familyNameErrors);
    setFamilyContactError(validation.familyContactErrors);
    setNameError(validation.emergencyNameErrors);
    setContactError(validation.emergencyContactErrors);
    setAckError(false);
    setProfileError(
      validation.missingProfile ? "Please upload profilePhoto" : " ",
    );
    setSignatureFileNameError(
      validation.missingSignature ? "Please upload signature" : " ",
    );

    const hasFieldErrors =
      !validation.check ||
      validation.sectionError.mother.motherName ||
      validation.sectionError.father.fatherName ||
      validation.sectionError.secondaryEmail ||
      validation.sectionError.altPhoneNumber ||
      validation.sectionError.passport ||
      validation.sectionError.pf ||
      validation.sectionError.uan ||
      validation.sectionError.ESIC ||
      validation.sectionError.currentAddress.postalCode ||
      validation.sectionError.permanentAddress.postalCode ||
      validation.sectionError.spouse ||
      validation.sectionError.isFresher ||
      validation.sectionError.religion ||
      validation.familyNameErrors.some((item) => item.name) ||
      validation.familyContactErrors.some((item) => item.contact) ||
      validation.emergencyNameErrors.some((item) => item.name) ||
      validation.emergencyContactErrors.some((item) => item.contact) ||
      validation.missingProfile ||
      validation.missingSignature;

    if (hasFieldErrors) {
      if (validation.missingProfile) {
        toast.error("Please upload profilephoto", {
          hideProgressBar: true,
          closeOnClick: true,
        });
      }
      if (validation.missingSignature) {
        toast.error("Please upload signature", {
          hideProgressBar: true,
          closeOnClick: true,
        });
      }
      scrollToSectionAError(fieldFirstSelector || undefined);
      console.log("field empty");
      return;
    }

    if (validation.missingAck) {
      setAckError(true);
      toast.error("Please acknowledge the details added by you are true", {
        hideProgressBar: true,
        closeOnClick: true,
      });
      scrollToSectionAError("#sectionA-acknowledgement");
      return;
    }

    handleButtonClick("sectionA", !user.isFresher ? "Fresher" : "");
    const userDest = { ...user, passport: validation.normalizedPassport };
    userDest["profilePhoto_fileName"] = profileFileName
      ? profileFileName
      : user.profilePhoto_fileName;
    userDest["signature_fileName"] = fileName
      ? fileName
      : user.signature_fileName;
    setLoadingButton(true);
    UserAPI.updateUser(
      reduxUser.user.isAdmin ? id : reduxUser.user._id,
      userDest,
    )
      .then(async (res) => {
        setLoadingButton(false);
        // After official save, clear any existing draft for this section.
        if (!reduxUser.user.isAdmin) {
          await deleteDraft();
        }
        if (!user.isFresher) {
          changeTab(2);
        } else {
          changeTab(1);
        }
      })
      .catch((err) => {
        setTimeout(() => {
          setLoadingButton(false);
        }, 10000);
        console.log(err);
      });
  };

  return (
    <div>
      <div className="col-lg-12">
        <div className="col-lg-12 mb-4">
          <h3>Basic Info</h3>
        </div>
        <div className="col-10 p-3 px-5 employeedetails mb-3">
          <div className="row my-3">
            <div className="col-4 text-center px-2 py-4 bg-white rounded">
              <div className="">
                {!image ? (
                  <img
                    className="rounded-circle border img-fluid"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                    }}
                    src={
                      user.profilePhoto ? user.profilePhoto : Uploadphotoicon
                    }
                  />
                ) : (
                  <img
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                    }}
                    className="rounded-circle border img-fluid"
                    id="profilePicture"
                    src=""
                    alt=""
                  />
                )}
              </div>
              <Button
                id="sectionA-profile-upload"
                sx={{ width: "200px", fontSize: "12px", marginTop: "25px" }}
                variant="contained"
                component="label"
              >
                <b>Upload Profile Picture</b>
                <input
                  onChange={(e) => handleImageUpload(e, 1)}
                  hidden
                  accept=".jpg, .jpeg, .png"
                  type="file"
                />
              </Button>
              <div>
                <span style={{ color: "red", fontSize: "15px" }}>
                  {profileError}
                </span>
              </div>

              {!sign ? (
                <Button
                  id="sectionA-signature-upload"
                  sx={{ width: "200px", fontSize: "12px", marginTop: "25px" }}
                  variant="contained"
                  component="label"
                >
                  <b>Upload Signature</b>

                  <input
                    onChange={(e) => handleImageUpload(e, 2)}
                    hidden
                    accept=".jpg, .jpeg, .png"
                    type="file"
                  />
                </Button>
              ) : (
                <div
                  id="sectionA-signature-upload"
                  className="my-3"
                  style={{ wordBreak: "break-all" }}
                >
                  <span>{user.signature_fileName || fileName}</span>
                  <CloseIcon sx={{ marginLeft: "10px" }} onClick={handleSign} />
                </div>
              )}

              <div>
                <span style={{ color: "red", fontSize: "15px" }}>
                  {signatureFileNameError}
                </span>
              </div>
            </div>
            <div className="col-8 ps-4">
              <div className="row">
                <div className="col-4 employeeContent">
                  <div className="col">Company Name :</div>
                  <div className="col">Employee Name :</div>
                  <div className="col">Designation :</div>
                  <div className="col">Date of Join :</div>
                  <div className="col">Work Location :</div>
                  <div className="col">Aadhar Number :</div>
                  <div className="col">PAN No :</div>
                  <div className="col">Personal Email Id :</div>
                  <div className="col">Phone Number :</div>
                </div>
                <div className="col employeeContent fw-bold ">
                  <div className="col text-align-start">{user.companyName}</div>
                  <div className="col text-align-start">{user.name}</div>
                  <div className="col text-align-start">{user.designation}</div>
                  <div className="col text-align-start">
                    {formatDate(user.doj)}
                  </div>
                  <div className="col text-align-start">
                    {user.workLocation}
                  </div>
                  <div className="col text-align-start">{user.aadhaar}</div>
                  <div className="col text-align-start">{user.pan}</div>
                  <div className="col text-align-start">{user.email}</div>
                  <div className="col text-align-start">{user.phoneNumber}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 py-3">
          <div className="col-7 d-flex mb-4">
            <TextField
              value={user.secondaryEmail}
              onChange={(e) => handleSecondDaryEmailChange(e)}
              sx={{ width: "300px", marginRight: "5%" }}
              id="sectionA-secondary-email"
              label="Secondary email (If Any)"
              variant="outlined"
              error={error.secondaryEmail}
              helperText={error.secondaryEmail ? "Invalid email" : ""}
              disabled={
                reduxUser.user.isAdmin &&
                (newJoineeSectionAFlagButton === "pending" ||
                  newJoineeSectionAFlagButton === "submitted" ||
                  newJoineeSectionAFlagButton === "review done" ||
                  newJoineeSectionAFlagButton === "resubmission required")
              }
            />
            <TextField
              value={user.altPhoneNumber}
              onChange={(e) => handleAlternateNumberChange(e)}
              sx={{ width: "300px", marginRight: "5%" }}
              id="sectionA-alt-phone"
              type="number"
              label="Alternate Phone Number"
              variant="outlined"
              error={error.altPhoneNumber}
              helperText={error.altPhoneNumber ? "Invalid Number" : ""}
              disabled={
                reduxUser.user.isAdmin &&
                (newJoineeSectionAFlagButton === "pending" ||
                  newJoineeSectionAFlagButton === "submitted" ||
                  newJoineeSectionAFlagButton === "review done" ||
                  newJoineeSectionAFlagButton === "resubmission required")
              }
            />
          </div>

          <div className="col-7 d-flex mb-4">
            <TextField
              error={validateerror ? validateerror[0].status : ""}
              onChange={(e) => handleFamilyChange(e, "mother", "name")}
              value={user.mother.name}
              sx={{ width: "300px", marginRight: "5%" }}
              id="sectionA-mother-name"
              label="Mother's Name"
              variant="outlined"
              helperText={error.mother.motherName ? "Invalid Name" : ""}
              required
              disabled={
                reduxUser.user.isAdmin &&
                (newJoineeSectionAFlagButton === "pending" ||
                  newJoineeSectionAFlagButton === "submitted" ||
                  newJoineeSectionAFlagButton === "review done" ||
                  newJoineeSectionAFlagButton === "resubmission required")
              }
            />
            <TextField
              error={validateerror ? validateerror[1].status : ""}
              onChange={(e) => handleFamilyChange(e, "mother", "occupation")}
              value={user.mother.occupation}
              sx={{ width: "300px" }}
              id="sectionA-mother-occupation"
              label="Mother's Occupation"
              variant="outlined"
              required
              disabled={
                reduxUser.user.isAdmin &&
                (newJoineeSectionAFlagButton === "pending" ||
                  newJoineeSectionAFlagButton === "submitted" ||
                  newJoineeSectionAFlagButton === "review done" ||
                  newJoineeSectionAFlagButton === "resubmission required")
              }
            />
          </div>

          <div className="col-7 d-flex mb-4">
            <TextField
              error={validateerror ? validateerror[2].status : ""}
              onChange={(e) => handleFamilyChange2(e, "father", "name")}
              value={user.father.name}
              sx={{ width: "300px", marginRight: "5%" }}
              id="sectionA-father-name"
              label="Father's Name"
              variant="outlined"
              helperText={error.father.fatherName ? "Invalid Name" : ""}
              required
              disabled={
                reduxUser.user.isAdmin &&
                (newJoineeSectionAFlagButton === "pending" ||
                  newJoineeSectionAFlagButton === "submitted" ||
                  newJoineeSectionAFlagButton === "review done" ||
                  newJoineeSectionAFlagButton === "resubmission required")
              }
            />
            <TextField
              error={validateerror ? validateerror[3].status : ""}
              onChange={(e) => handleFamilyChange2(e, "father", "occupation")}
              value={user.father.occupation}
              sx={{ width: "300px" }}
              id="sectionA-father-occupation"
              label="Father's Occupation"
              variant="outlined"
              required
              disabled={
                reduxUser.user.isAdmin &&
                (newJoineeSectionAFlagButton === "pending" ||
                  newJoineeSectionAFlagButton === "submitted" ||
                  newJoineeSectionAFlagButton === "review done" ||
                  newJoineeSectionAFlagButton === "resubmission required")
              }
            />
          </div>

          <div
            className="mb-3"
            id="sectionA-gender-group"
            data-section-a-error={
              validateerror && validateerror[4].status ? "true" : undefined
            }
          >
            <FormControl fullWidth>
              <FormLabel
                sx={{ color: "black" }}
                id="demo-row-radio-buttons-group-label"
              >
                Gender
              </FormLabel>
              <FormLabel
                data-section-a-error={
                  validateerror && validateerror[4].status ? "true" : undefined
                }
                style={{
                  display:
                    validateerror && validateerror[4].status ? "" : "none",
                }}
                sx={{ color: "red" }}
                id="demo-row-radio-buttons-group-label"
              >
                (please select gender)
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                sx={{ paddingLeft: "1%" }}
                value={user.gender}
                onChange={(e) => handleGender(e)}
                required
              >
                <FormControlLabel
                  value="female"
                  control={<Radio />}
                  label="Female"
                  disabled={
                    reduxUser.user.isAdmin &&
                    (newJoineeSectionAFlagButton === "pending" ||
                      newJoineeSectionAFlagButton === "submitted" ||
                      newJoineeSectionAFlagButton === "review done" ||
                      newJoineeSectionAFlagButton === "resubmission required")
                  }
                />
                <FormControlLabel
                  value="male"
                  control={<Radio />}
                  label="Male"
                  disabled={
                    reduxUser.user.isAdmin &&
                    (newJoineeSectionAFlagButton === "pending" ||
                      newJoineeSectionAFlagButton === "submitted" ||
                      newJoineeSectionAFlagButton === "review done" ||
                      newJoineeSectionAFlagButton === "resubmission required")
                  }
                />
                <FormControlLabel
                  value="NA"
                  control={<Radio />}
                  label="Prefer Not to Answer"
                  disabled={
                    reduxUser.user.isAdmin &&
                    (newJoineeSectionAFlagButton === "pending" ||
                      newJoineeSectionAFlagButton === "submitted" ||
                      newJoineeSectionAFlagButton === "review done" ||
                      newJoineeSectionAFlagButton === "resubmission required")
                  }
                />
              </RadioGroup>
            </FormControl>
          </div>

          <div className="col-7 d-flex mb-3">
            <div
              id="sectionA-dob"
              data-section-a-error={
                validateerror && validateerror[24] && validateerror[24].status
                  ? "true"
                  : undefined
              }
              style={{
                display: "flex",
                flexDirection: "column",
                marginRight: "5%",
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  sx={{ width: "300px" }}
                  label="Date of birth"
                  value={user.dateOfBirth ? dayjs(user.dateOfBirth) : null}
                  onChange={(date) => handleDateOfBirth(date)}
                  renderInput={(params) => <TextField {...params} />}
                  format="DD/MM/YYYY"
                  error={validateerror ? validateerror[24].status : ""}
                  required
                  disabled={
                    reduxUser.user.isAdmin &&
                    (newJoineeSectionAFlagButton === "pending" ||
                      newJoineeSectionAFlagButton === "submitted" ||
                      newJoineeSectionAFlagButton === "review done" ||
                      newJoineeSectionAFlagButton === "resubmission required")
                  }
                />
              </LocalizationProvider>
              <FormLabel
                data-section-a-error={
                  validateerror && validateerror[24] && validateerror[24].status
                    ? "true"
                    : undefined
                }
                style={{
                  display:
                    validateerror &&
                    validateerror[24] &&
                    validateerror[24].status
                      ? ""
                      : "none",
                }}
                sx={{ color: "red" }}
              >
                (please select date)
              </FormLabel>
            </div>

            <FormControl>
              <InputLabel id="demo-simple-select-label">Blood Group</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={user.bloodGroup}
                label="Blood Group"
                sx={{ width: "300px" }}
                onChange={(e) => handleBloodGroup(e)}
                disabled={
                  reduxUser.user.isAdmin &&
                  (newJoineeSectionAFlagButton === "pending" ||
                    newJoineeSectionAFlagButton === "submitted" ||
                    newJoineeSectionAFlagButton === "review done" ||
                    newJoineeSectionAFlagButton === "resubmission required")
                }
              >
                <MenuItem value={"A+"}>A+</MenuItem>
                <MenuItem value={"B+"}>B+</MenuItem>
                <MenuItem value={"A-"}>A-</MenuItem>
                <MenuItem value={"B-"}>B-</MenuItem>
                <MenuItem value={"O+"}>O+</MenuItem>
                <MenuItem value={"O-"}>O-</MenuItem>
                <MenuItem value={"AB+"}>AB+</MenuItem>
                <MenuItem value={"AB-"}>AB-</MenuItem>
              </Select>
            </FormControl>
          </div>

          <div className="col-3 mb-3">
            <TextField
              onChange={(e) => handleReligion(e)}
              value={user.religion}
              fullWidth
              id="sectionA-religion"
              label="Religion"
              variant="outlined"
              error={
                validateerror
                  ? validateerror[6].status || error.religion
                  : error.religion
              }
              helperText={error.religion ? "Invalid Religion" : ""}
              required
              disabled={
                reduxUser.user.isAdmin &&
                (newJoineeSectionAFlagButton === "pending" ||
                  newJoineeSectionAFlagButton === "submitted" ||
                  newJoineeSectionAFlagButton === "review done" ||
                  newJoineeSectionAFlagButton === "resubmission required")
              }
            />
          </div>

          <div
            className="mb-3"
            id="sectionA-marital-status-group"
            data-section-a-error={
              validateerror && validateerror[5].status ? "true" : undefined
            }
          >
            <FormControl fullWidth>
              <FormLabel
                sx={{ color: "black" }}
                id="demo-row-radio-buttons-group-label"
              >
                Marital Status
              </FormLabel>
              <FormLabel
                data-section-a-error={
                  validateerror && validateerror[5].status ? "true" : undefined
                }
                style={{
                  display:
                    validateerror && validateerror[5].status ? "" : "none",
                }}
                sx={{ color: "red" }}
              >
                (please select marital status)
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                sx={{ paddingLeft: "1%" }}
                value={user.maritalStatus}
                onChange={(e) => handleMaritalStatus(e)}
                required
              >
                <FormControlLabel
                  value={"married"}
                  control={<Radio />}
                  label="Married"
                  disabled={
                    reduxUser.user.isAdmin &&
                    (newJoineeSectionAFlagButton === "pending" ||
                      newJoineeSectionAFlagButton === "submitted" ||
                      newJoineeSectionAFlagButton === "review done" ||
                      newJoineeSectionAFlagButton === "resubmission required")
                  }
                />
                <FormControlLabel
                  value="single"
                  control={<Radio />}
                  label="UnMarried"
                  disabled={
                    reduxUser.user.isAdmin &&
                    (newJoineeSectionAFlagButton === "pending" ||
                      newJoineeSectionAFlagButton === "submitted" ||
                      newJoineeSectionAFlagButton === "review done" ||
                      newJoineeSectionAFlagButton === "resubmission required")
                  }
                />
                <FormControlLabel
                  value="widow"
                  control={<Radio />}
                  label="Widow"
                  disabled={
                    reduxUser.user.isAdmin &&
                    (newJoineeSectionAFlagButton === "pending" ||
                      newJoineeSectionAFlagButton === "submitted" ||
                      newJoineeSectionAFlagButton === "review done" ||
                      newJoineeSectionAFlagButton === "resubmission required")
                  }
                />
                <FormControlLabel
                  value="widower"
                  control={<Radio />}
                  label="Widower"
                  disabled={
                    reduxUser.user.isAdmin &&
                    (newJoineeSectionAFlagButton === "pending" ||
                      newJoineeSectionAFlagButton === "submitted" ||
                      newJoineeSectionAFlagButton === "review done" ||
                      newJoineeSectionAFlagButton === "resubmission required")
                  }
                />
                <FormControlLabel
                  value="divorcee"
                  control={<Radio />}
                  label="Divorcee"
                  disabled={
                    reduxUser.user.isAdmin &&
                    (newJoineeSectionAFlagButton === "pending" ||
                      newJoineeSectionAFlagButton === "submitted" ||
                      newJoineeSectionAFlagButton === "review done" ||
                      newJoineeSectionAFlagButton === "resubmission required")
                  }
                />
              </RadioGroup>
            </FormControl>
          </div>

          {user.maritalStatus === "married" ? (
            <div className="col-3 mb-4">
              <TextField
                onChange={(e) => handleSpouseChange(e)}
                value={user.spouse}
                fullWidth
                id="sectionA-spouse"
                label="Spouse Name"
                variant="outlined"
                error={error.spouse}
                helperText={error.spouse ? "Please select spouse name" : ""}
                required
                disabled={
                  reduxUser.user.isAdmin &&
                  (newJoineeSectionAFlagButton === "pending" ||
                    newJoineeSectionAFlagButton === "submitted" ||
                    newJoineeSectionAFlagButton === "review done" ||
                    newJoineeSectionAFlagButton === "resubmission required")
                }
              />
            </div>
          ) : (
            <></>
          )}

          <section
            className="col-12 mb-3 px-1 sudexoclass"
            id="sectionA-experience-group"
            data-section-a-error={error.isFresher ? "true" : undefined}
          >
            <FormControlLabel
              onChange={(e) => handleFresherChecked(e)}
              value={user.isFresher}
              control={<Checkbox />}
              checked={user.isFresher}
              label="Do you have any prior work experience?"
              disabled={
                reduxUser.user.isAdmin &&
                (newJoineeSectionAFlagButton === "pending" ||
                  newJoineeSectionAFlagButton === "submitted" ||
                  newJoineeSectionAFlagButton === "review done" ||
                  newJoineeSectionAFlagButton === "resubmission required")
              }
            />
            <p style={{ color: "red", fontSize: "13px", marginLeft: "25px" }}>
              {error.isFresher ? (
                <span data-section-a-error="true">
                  Do you have experience if no then select checkbox
                </span>
              ) : (
                ""
              )}
            </p>
          </section>

          {user.isFresher && (
            <div className="col-12 mb-4">
              <FormLabel sx={{ marginBottom: "1%", color: "black" }}>
                Experience in Years
              </FormLabel>
              <br />
              <div style={{ display: "flex", gap: "20px" }}>
                <div>
                  <FormLabel sx={{ marginBottom: "5%", color: "black" }}>
                    Total Experience
                  </FormLabel>
                  <br />
                  <div style={{ display: "flex", gap: "5px" }}>
                    <FormControl sx={{ width: "100px", marginRight: "1%" }}>
                      <InputLabel id="demo-simple-select-label">
                        Years
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={
                          user.isFresher ? user.totalExperienceInYears : ""
                        }
                        label="Total"
                        onChange={(e) => handleTotalExperienceInYears(e)}
                        disabled={
                          !user.isFresher ||
                          (reduxUser.user.isAdmin &&
                            (newJoineeSectionAFlagButton === "pending" ||
                              newJoineeSectionAFlagButton === "submitted" ||
                              newJoineeSectionAFlagButton === "review done" ||
                              newJoineeSectionAFlagButton ===
                                "resubmission required"))
                        }
                        required
                      >
                        {totalExpInYr.map((year, index) => (
                          <MenuItem key={index} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl sx={{ width: "100px", marginRight: "1%" }}>
                      <InputLabel id="demo-simple-select-label">
                        Months
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={
                          user.isFresher ? user.totalExperienceInMonths : ""
                        }
                        label="Total"
                        onChange={(e) => handleTotalExperienceInMonths(e)}
                        required
                        disabled={
                          !user.isFresher ||
                          (reduxUser.user.isAdmin &&
                            (newJoineeSectionAFlagButton === "pending" ||
                              newJoineeSectionAFlagButton === "submitted" ||
                              newJoineeSectionAFlagButton === "review done" ||
                              newJoineeSectionAFlagButton ===
                                "resubmission required"))
                        }
                      >
                        {totalExpInMonth.map((month) => (
                          <MenuItem key={month} value={month}>
                            {month}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>

                <div>
                  <FormLabel sx={{ marginBottom: "5%", color: "black" }}>
                    Relavant Experience
                  </FormLabel>
                  <br />
                  <div style={{ display: "flex", gap: "5px" }}>
                    <FormControl sx={{ width: "100px", marginRight: "1%" }}>
                      <InputLabel id="demo-simple-select-label">
                        Years
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={
                          user.isFresher ? user.relevantExperienceInYears : ""
                        }
                        label="Relevant"
                        onChange={(e) => handleRelavantExperienceInYears(e)}
                        disabled={
                          !user.isFresher ||
                          (reduxUser.user.isAdmin &&
                            (newJoineeSectionAFlagButton === "pending" ||
                              newJoineeSectionAFlagButton === "submitted" ||
                              newJoineeSectionAFlagButton === "review done" ||
                              newJoineeSectionAFlagButton ===
                                "resubmission required"))
                        }
                        required
                      >
                        {totalExpInYr.map(
                          (year, index) =>
                            (user.totalExperienceInYears >= year ||
                              user.totalExperienceInYears == "20+") && (
                              <MenuItem key={index} value={year}>
                                {year}
                              </MenuItem>
                            ),
                        )}
                      </Select>
                    </FormControl>

                    <FormControl sx={{ width: "100px", marginRight: "1%" }}>
                      <InputLabel id="demo-simple-select-label">
                        Months
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={
                          user.isFresher ? user.relevantExperienceInMonths : ""
                        }
                        label="Relevant"
                        onChange={(e) => handleRelavantExperienceInMonths(e)}
                        disabled={
                          !user.isFresher ||
                          (reduxUser.user.isAdmin &&
                            (newJoineeSectionAFlagButton === "pending" ||
                              newJoineeSectionAFlagButton === "submitted" ||
                              newJoineeSectionAFlagButton === "review done" ||
                              newJoineeSectionAFlagButton ===
                                "resubmission required"))
                        }
                        required
                      >
                        {totalExpInMonth.map(
                          (month) =>
                            (user.relevantExperienceInYears <
                              user.totalExperienceInYears ||
                              (user.relevantExperienceInYears ===
                                user.totalExperienceInYears &&
                                month <= user.totalExperienceInMonths)) && (
                              <MenuItem key={month} value={month}>
                                {month}
                              </MenuItem>
                            ),
                        )}
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="mb-3" id="sectionA-passport-group">
            <FormControl fullWidth>
              <FormLabel
                sx={{ color: "black" }}
                id="demo-row-radio-buttons-group-label"
              >
                Do you have Passport ?
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                sx={{ paddingLeft: "1%" }}
                value={user.isPassport}
                onChange={(e) => handlePassportStatus(e)}
              >
                <FormControlLabel
                  value={"true"}
                  control={<Radio />}
                  label="Yes"
                  disabled={
                    reduxUser.user.isAdmin &&
                    (newJoineeSectionAFlagButton === "pending" ||
                      newJoineeSectionAFlagButton === "submitted" ||
                      newJoineeSectionAFlagButton === "review done" ||
                      newJoineeSectionAFlagButton === "resubmission required")
                  }
                />
                <FormControlLabel
                  value={"false"}
                  control={<Radio />}
                  label="No"
                  disabled={
                    reduxUser.user.isAdmin &&
                    (newJoineeSectionAFlagButton === "pending" ||
                      newJoineeSectionAFlagButton === "submitted" ||
                      newJoineeSectionAFlagButton === "review done" ||
                      newJoineeSectionAFlagButton === "resubmission required")
                  }
                />
              </RadioGroup>
            </FormControl>
          </div>

          {user.isPassport === "true" ? (
            <div className="row">
              <div className="col-3 mb-4">
                <TextField
                  onChange={(e) => handlePassportInput(e)}
                  value={user.passport}
                  fullWidth
                  id="sectionA-passport-number"
                  label="Passport Number"
                  variant="outlined"
                  error={error.passport}
                  helperText={error.passport ? "Invalid Passport" : ""}
                  required
                  disabled={
                    reduxUser.user.isAdmin &&
                    (newJoineeSectionAFlagButton === "pending" ||
                      newJoineeSectionAFlagButton === "submitted" ||
                      newJoineeSectionAFlagButton === "review done" ||
                      newJoineeSectionAFlagButton === "resubmission required")
                  }
                />
              </div>
              <div className="col-4 mb-4">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    sx={{ width: "20ch" }}
                    label="Passport Expiry Date"
                    value={
                      user.passportExpiry ? dayjs(user.passportExpiry) : null
                    }
                    onChange={(date) => handlePassportExpiryDate(date)}
                    renderInput={(params) => <TextField {...params} />}
                    format="DD/MM/YYYY"
                    disabled={
                      reduxUser.user.isAdmin &&
                      (newJoineeSectionAFlagButton === "pending" ||
                        newJoineeSectionAFlagButton === "submitted" ||
                        newJoineeSectionAFlagButton === "review done" ||
                        newJoineeSectionAFlagButton === "resubmission required")
                    }
                  />
                </LocalizationProvider>
              </div>
            </div>
          ) : (
            <></>
          )}

          <div className="col-3 d-flex justify-content-between mb-4">
            <TextField
              onChange={(e) => handleLinkedIn(e)}
              value={user.linkedIn}
              fullWidth
              id="outlined-basic"
              label="Linkedin Profile Url"
              variant="outlined"
              disabled={
                reduxUser.user.isAdmin &&
                (newJoineeSectionAFlagButton === "pending" ||
                  newJoineeSectionAFlagButton === "submitted" ||
                  newJoineeSectionAFlagButton === "review done" ||
                  newJoineeSectionAFlagButton === "resubmission required")
              }
            />
          </div>

          <div className="col-7 d-flex  mb-4">
            <TextField
              onChange={(e) => handlePF(e)}
              value={user.pf}
              sx={{ width: "380px", marginRight: "5%" }}
              id="sectionA-pf"
              label="PF Number"
              variant="outlined"
              inputProps={{ className: "number-input" }}
              error={error.pf}
              helperText=""
              disabled={
                reduxUser.user.isAdmin &&
                (newJoineeSectionAFlagButton === "pending" ||
                  newJoineeSectionAFlagButton === "submitted" ||
                  newJoineeSectionAFlagButton === "review done" ||
                  newJoineeSectionAFlagButton === "resubmission required")
              }
            />
            <TextField
              onChange={(e) => handleUAN(e)}
              value={user.uan}
              sx={{ width: "300px", marginRight: "5%" }}
              id="sectionA-uan"
              label="UAN Number"
              variant="outlined"
              type="number"
              error={error.uan}
              helperText={error.uan ? "Invalid UAN Number" : ""}
              disabled={
                reduxUser.user.isAdmin &&
                (newJoineeSectionAFlagButton === "pending" ||
                  newJoineeSectionAFlagButton === "submitted" ||
                  newJoineeSectionAFlagButton === "review done" ||
                  newJoineeSectionAFlagButton === "resubmission required")
              }
            />
            <TextField
              onChange={(e) => handleESIC(e)}
              value={user.ESIC}
              sx={{ width: "300px" }}
              id="sectionA-esic"
              label="ESIC Number"
              variant="outlined"
              type="number"
              error={error.ESIC}
              helperText={error.ESIC ? "Invalid ESIC Number" : ""}
              disabled={
                reduxUser.user.isAdmin &&
                (newJoineeSectionAFlagButton === "pending" ||
                  newJoineeSectionAFlagButton === "submitted" ||
                  newJoineeSectionAFlagButton === "review done" ||
                  newJoineeSectionAFlagButton === "resubmission required")
              }
            />
          </div>

          <div
            className="col-6 mb-4"
            id="sectionA-skills"
            data-section-a-error={
              validateerror && validateerror[7].status ? "true" : undefined
            }
          >
            <FormLabel
              sx={{ marginBottom: "3%", color: "black", fontWeight: "600" }}
            >
              Skills
            </FormLabel>
            <br />
            <SelectSkills setUser={setUser} skills={user.skills} />
            {validateerror && validateerror[7].status ? (
              <div style={{ color: "red", marginTop: "4px" }}>
                Please select skills
              </div>
            ) : null}
          </div>

          <div className="col-11 ms-4 mb-4 border-bottom border-2"></div>
          <section className="col-12 mb-4">
            <div className="my-3">
              <h4>Address details</h4>
            </div>
            <div className="m-0 col-10 py-3 px-3 row">
              <div className="col">
                <h5>Current Address</h5>
                <p>Mention your current address for communication</p>
                <div className="mb-2">
                  <TextField
                    error={validateerror ? validateerror[8].status : ""}
                    onChange={(e) =>
                      handleAddressChange(e, "currentAddress", 1)
                    }
                    value={user.currentAddress.addressLine1}
                    sx={{ width: "400px" }}
                    id="sectionA-current-address-line1"
                    label="Address Line 1"
                    variant="outlined"
                    required
                    disabled={
                      reduxUser.user.isAdmin &&
                      (newJoineeSectionAFlagButton === "pending" ||
                        newJoineeSectionAFlagButton === "submitted" ||
                        newJoineeSectionAFlagButton === "review done" ||
                        newJoineeSectionAFlagButton === "resubmission required")
                    }
                  />
                </div>
                <div className="mb-2">
                  <TextField
                    error={validateerror ? validateerror[9].status : ""}
                    onChange={(e) =>
                      handleAddressChange(e, "currentAddress", 2)
                    }
                    value={user.currentAddress.addressLine2}
                    sx={{ width: "400px" }}
                    id="sectionA-current-address-line2"
                    label="Address Line 2"
                    variant="outlined"
                    required
                    disabled={
                      reduxUser.user.isAdmin &&
                      (newJoineeSectionAFlagButton === "pending" ||
                        newJoineeSectionAFlagButton === "submitted" ||
                        newJoineeSectionAFlagButton === "review done" ||
                        newJoineeSectionAFlagButton === "resubmission required")
                    }
                  />
                </div>
                <div className="mb-2">
                  <TextField
                    error={validateerror ? validateerror[10].status : ""}
                    onChange={(e) =>
                      handleAddressChange(e, "currentAddress", 3)
                    }
                    value={user.currentAddress.addressLine3}
                    sx={{ width: "400px" }}
                    id="sectionA-current-address-line3"
                    label="Address Line 3"
                    variant="outlined"
                    required
                    disabled={
                      reduxUser.user.isAdmin &&
                      (newJoineeSectionAFlagButton === "pending" ||
                        newJoineeSectionAFlagButton === "submitted" ||
                        newJoineeSectionAFlagButton === "review done" ||
                        newJoineeSectionAFlagButton === "resubmission required")
                    }
                  />
                </div>
                <div className="mb-2">
                  <TextField
                    onChange={(e) =>
                      handleAddressChange(e, "currentAddress", 4)
                    }
                    value={user.currentAddress.landmark}
                    sx={{ width: "400px" }}
                    id="outlined-basic"
                    label="Landmark"
                    variant="outlined"
                    disabled={
                      reduxUser.user.isAdmin &&
                      (newJoineeSectionAFlagButton === "pending" ||
                        newJoineeSectionAFlagButton === "submitted" ||
                        newJoineeSectionAFlagButton === "review done" ||
                        newJoineeSectionAFlagButton === "resubmission required")
                    }
                  />
                </div>
                <div className="mb-2">
                  <TextField
                    error={
                      validateerror
                        ? validateerror[11].status ||
                          error.currentAddress.postalCode
                        : error.currentAddress.postalCode
                    }
                    onChange={(e) =>
                      handleAddressChange(e, "currentAddress", 5)
                    }
                    value={user.currentAddress.postalCode}
                    sx={{ width: "400px" }}
                    id="sectionA-current-postal-code"
                    label="PostalCode"
                    variant="outlined"
                    type="number"
                    helperText={
                      error.currentAddress.postalCode
                        ? "Invalid postalCode"
                        : ""
                    }
                    required
                    disabled={
                      reduxUser.user.isAdmin &&
                      (newJoineeSectionAFlagButton === "pending" ||
                        newJoineeSectionAFlagButton === "submitted" ||
                        newJoineeSectionAFlagButton === "review done" ||
                        newJoineeSectionAFlagButton === "resubmission required")
                    }
                  />
                </div>
                <div className="mb-2">
                  <TextField
                    onChange={(e) =>
                      handleAddressChange(e, "currentAddress", 6)
                    }
                    error={
                      validateerror && validateerror[18]
                        ? validateerror[18].status
                        : ""
                    }
                    value={user.currentAddress.periodOfStay}
                    sx={{ width: "400px" }}
                    id="sectionA-current-period"
                    type="number"
                    label="Period of stay (in years)"
                    variant="outlined"
                    required
                    disabled={
                      reduxUser.user.isAdmin &&
                      (newJoineeSectionAFlagButton === "pending" ||
                        newJoineeSectionAFlagButton === "submitted" ||
                        newJoineeSectionAFlagButton === "review done" ||
                        newJoineeSectionAFlagButton === "resubmission required")
                    }
                  />
                </div>
                <div>
                  <TextField
                    select
                    sx={{ width: "400px" }}
                    label="Nature of residency"
                    id="sectionA-current-residency"
                    value={user.currentAddress.natureOfResidency}
                    error={
                      validateerror && validateerror[19]
                        ? validateerror[19].status
                        : ""
                    }
                    onChange={(e) =>
                      handleAddressChange(e, "currentAddress", 7)
                    }
                    required
                    disabled={
                      reduxUser.user.isAdmin &&
                      (newJoineeSectionAFlagButton === "pending" ||
                        newJoineeSectionAFlagButton === "submitted" ||
                        newJoineeSectionAFlagButton === "review done" ||
                        newJoineeSectionAFlagButton === "resubmission required")
                    }
                  >
                    <MenuItem value={"Own-house"}>Own House</MenuItem>
                    <MenuItem value={"Rented"}>Rented</MenuItem>
                    <MenuItem value={"Parental"}>Parental</MenuItem>
                  </TextField>
                </div>
              </div>

              <div className="col-1 border-start border-dark border-1"></div>
              <div className="col">
                <h5>Permanent Address</h5>
                <FormControlLabel
                  onChange={(e) => handleAddressSame(e)}
                  value={user.permanentAddressSame}
                  control={<Checkbox />}
                  checked={user.permanentAddressSame}
                  label="Same as current"
                  disabled={
                    reduxUser.user.isAdmin &&
                    (newJoineeSectionAFlagButton === "pending" ||
                      newJoineeSectionAFlagButton === "submitted" ||
                      newJoineeSectionAFlagButton === "review done" ||
                      newJoineeSectionAFlagButton === "resubmission required")
                  }
                />

                <div className="mb-2">
                  <TextField
                    onChange={(e) =>
                      handleAddressChange(e, "permanentAddress", 1)
                    }
                    error={validateerror ? validateerror[20].status : ""}
                    disabled={user.permanentAddressSame}
                    value={
                      user.permanentAddressSame
                        ? user.currentAddress.addressLine1
                        : user.permanentAddress.addressLine1
                    }
                    sx={{ width: "400px" }}
                    id="sectionA-permanent-address-line1"
                    label="Address Line 1"
                    variant="outlined"
                    required
                  />
                </div>
                <div className="mb-2">
                  <TextField
                    onChange={(e) =>
                      handleAddressChange(e, "permanentAddress", 2)
                    }
                    error={validateerror ? validateerror[21].status : ""}
                    disabled={user.permanentAddressSame}
                    value={
                      user.permanentAddressSame
                        ? user.currentAddress.addressLine2
                        : user.permanentAddress.addressLine2
                    }
                    sx={{ width: "400px" }}
                    id="sectionA-permanent-address-line2"
                    label="Address Line 2"
                    variant="outlined"
                    required
                  />
                </div>
                <div className="mb-2">
                  <TextField
                    onChange={(e) =>
                      handleAddressChange(e, "permanentAddress", 3)
                    }
                    error={validateerror ? validateerror[22].status : ""}
                    disabled={user.permanentAddressSame}
                    value={
                      user.permanentAddressSame
                        ? user.currentAddress.addressLine3
                        : user.permanentAddress.addressLine3
                    }
                    sx={{ width: "400px" }}
                    id="sectionA-permanent-address-line3"
                    label="Address Line 3"
                    variant="outlined"
                    required
                  />
                </div>
                <div className="mb-2">
                  <TextField
                    onChange={(e) =>
                      handleAddressChange(e, "permanentAddress", 4)
                    }
                    disabled={user.permanentAddressSame}
                    value={
                      user.permanentAddressSame
                        ? user.currentAddress.landmark
                        : user.permanentAddress.landmark
                    }
                    sx={{ width: "400px" }}
                    id="outlined-basic"
                    label="Landmark"
                    variant="outlined"
                  />
                </div>
                <div className="mb-2">
                  <TextField
                    onChange={(e) =>
                      handleAddressChange(e, "permanentAddress", 5)
                    }
                    error={
                      validateerror
                        ? validateerror[23].status ||
                          error.permanentAddress.postalCode
                        : error.permanentAddress.postalCode
                    }
                    disabled={user.permanentAddressSame}
                    value={
                      user.permanentAddressSame
                        ? user.currentAddress.postalCode
                        : user.permanentAddress.postalCode
                    }
                    sx={{ width: "400px" }}
                    id="sectionA-permanent-postal-code"
                    label="PostalCode"
                    variant="outlined"
                    helperText={
                      error.permanentAddress.postalCode
                        ? "Invalid postalCode"
                        : ""
                    }
                    required
                  />
                </div>
                <div className="mb-2">
                  <TextField
                    onChange={(e) =>
                      handleAddressChange(e, "permanentAddress", 6)
                    }
                    error={
                      validateerror && validateerror[25]
                        ? validateerror[25].status
                        : ""
                    }
                    value={
                      user.permanentAddressSame
                        ? user.currentAddress.periodOfStay
                        : user.permanentAddress.periodOfStay
                    }
                    sx={{ width: "400px" }}
                    id="sectionA-permanent-period"
                    type="number"
                    label="Period of stay (in years)"
                    variant="outlined"
                    required
                    disabled={user.permanentAddressSame}
                  />
                </div>
                <div>
                  <TextField
                    select
                    sx={{ width: "400px" }}
                    label="Nature of residency"
                    id="sectionA-permanent-residency"
                    value={
                      user.permanentAddressSame
                        ? user.currentAddress.natureOfResidency
                        : user.permanentAddress.natureOfResidency
                    }
                    error={
                      validateerror && validateerror[26]
                        ? validateerror[26].status
                        : ""
                    }
                    onChange={(e) =>
                      handleAddressChange(e, "permanentAddress", 7)
                    }
                    required
                    disabled={user.permanentAddressSame}
                  >
                    <MenuItem value={"Own-house"}>Own House</MenuItem>
                    <MenuItem value={"Rented"}>Rented</MenuItem>
                    <MenuItem value={"Parental"}>Parental</MenuItem>
                  </TextField>
                </div>
              </div>
            </div>
          </section>

          <div className="col-11 ms-4 mb-4 border-bottom border-2"></div>
          <section className="col-12 mb-4">
            <div className="my-3 row col-11">
              <h4 className="col">Add Family details</h4>
              <button
                onClick={(e) => handleAddFamily(e)}
                type="button"
                className="col-2 btn btn-outline-primary"
                disabled={
                  reduxUser.user.isAdmin &&
                  (newJoineeSectionAFlagButton === "pending" ||
                    newJoineeSectionAFlagButton === "submitted" ||
                    newJoineeSectionAFlagButton === "review done" ||
                    newJoineeSectionAFlagButton === "resubmission required")
                }
              >
                <span style={{ fontSize: "15px" }}>+ Add Family Member</span>
              </button>
            </div>
            {user.familyDetails.map((fam, index) => {
              return (
                <div className=" px-4">
                  <Box sx={{ width: "100%" }}>
                    <Grid container spacing={3} sx={{ marginBottom: "2%" }}>
                      <Grid item>
                        <TextField
                          required
                          sx={{ width: "32ch" }}
                          id={`sectionA-family-name-${index}`}
                          label="Name"
                          value={fam.name}
                          error={
                            validateerror && validateerror[12][index]
                              ? validateerror[12][index].status
                              : ""
                          }
                          onChange={(e) => handleFamily(e, index, "name")}
                          disabled={
                            reduxUser.user.isAdmin &&
                            (newJoineeSectionAFlagButton === "pending" ||
                              newJoineeSectionAFlagButton === "submitted" ||
                              newJoineeSectionAFlagButton === "review done" ||
                              newJoineeSectionAFlagButton ===
                                "resubmission required")
                          }
                          helperText={
                            familyNameError.length > 0 &&
                            familyNameError[index] &&
                            familyNameError[index].name
                              ? "Invalid Name"
                              : ""
                          }
                        />
                      </Grid>
                      <Grid item>
                        <TextField
                          required
                          sx={{ width: "32ch" }}
                          id={`sectionA-family-contact-${index}`}
                          label="Contact Number"
                          // type="number"
                          value={fam.contact}
                          error={
                            validateerror && validateerror[13][index]
                              ? validateerror[13][index].status ||
                                (familyContactError[index] &&
                                  familyContactError[index].contact)
                              : ""
                          }
                          onChange={(e) => handleFamily(e, index, "contact")}
                          disabled={
                            reduxUser.user.isAdmin &&
                            (newJoineeSectionAFlagButton === "pending" ||
                              newJoineeSectionAFlagButton === "submitted" ||
                              newJoineeSectionAFlagButton === "review done" ||
                              newJoineeSectionAFlagButton ===
                                "resubmission required")
                          }
                          helperText={
                            familyContactError.length > 0 &&
                            familyContactError[index] &&
                            familyContactError[index].contact
                              ? "Invalid Number"
                              : ""
                          }
                        />
                      </Grid>
                      <Grid item>
                        <TextField
                          select
                          sx={{ width: "32ch" }}
                          id={`sectionA-family-relationship-${index}`}
                          label="Select Relationship"
                          value={fam.relationship}
                          error={
                            validateerror && validateerror[14][index]
                              ? validateerror[14][index].status
                              : ""
                          }
                          onChange={(e) =>
                            handleFamily(e, index, "relationship")
                          }
                          required
                          disabled={
                            reduxUser.user.isAdmin &&
                            (newJoineeSectionAFlagButton === "pending" ||
                              newJoineeSectionAFlagButton === "submitted" ||
                              newJoineeSectionAFlagButton === "review done" ||
                              newJoineeSectionAFlagButton ===
                                "resubmission required")
                          }
                        >
                          <MenuItem value="mother">Mother</MenuItem>
                          <MenuItem value="father">Father</MenuItem>
                          <MenuItem value="spouse">Spouse</MenuItem>
                          <MenuItem value="sister">Sister</MenuItem>
                          <MenuItem value="brother">Brother</MenuItem>
                          <MenuItem value="son">Son</MenuItem>
                          <MenuItem value="daughter">Daughter</MenuItem>
                          <MenuItem value="guardian ">Guardian</MenuItem>
                        </TextField>

                        {index > 1 ? (
                          <DeleteForeverIcon
                            onClick={() => handleDeleteFamily(index)}
                            sx={{
                              color: "red",
                              cursor: "pointer",
                              marginLeft: "5px",
                              marginTop: "15px",
                            }}
                          />
                        ) : (
                          <> </>
                        )}
                      </Grid>
                    </Grid>
                  </Box>
                </div>
              );
            })}
          </section>

          <div className="col-11 ms-4 mb-4 border-bottom border-2"></div>
          <section className="col-12 mb-4">
            <h4 className="col my-3">Emergency Contact</h4>
            <div className="col-11 px-4">
              {user.emergencyContact.map((em, index) => {
                return (
                  <Box
                    component="form"
                    sx={{
                      "& .MuiTextField-root": { m: 1, width: "39ch" },
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <div>
                      <TextField
                        required
                        id={`sectionA-emergency-name-${index}`}
                        label="Name"
                        value={em.name}
                        error={
                          validateerror ? validateerror[15][index].status : ""
                        }
                        onChange={(e) => handleContact(e, index, "name")}
                        disabled={
                          reduxUser.user.isAdmin &&
                          (newJoineeSectionAFlagButton === "pending" ||
                            newJoineeSectionAFlagButton === "submitted" ||
                            newJoineeSectionAFlagButton === "review done" ||
                            newJoineeSectionAFlagButton ===
                              "resubmission required")
                        }
                        helperText={
                          nameError.length > 0 && nameError[index].name
                            ? "Invalid Name"
                            : ""
                        }
                      />
                      <TextField
                        required
                        type="number"
                        inputProps={{ className: "number-input" }}
                        id={`sectionA-emergency-contact-${index}`}
                        label="Contact Number"
                        value={em.contact}
                        error={
                          validateerror
                            ? validateerror[16][index].status ||
                              (contactError[index] && contactError[index].contact)
                            : ""
                        }
                        onChange={(e) => handleContact(e, index, "contact")}
                        disabled={
                          reduxUser.user.isAdmin &&
                          (newJoineeSectionAFlagButton === "pending" ||
                            newJoineeSectionAFlagButton === "submitted" ||
                            newJoineeSectionAFlagButton === "review done" ||
                            newJoineeSectionAFlagButton ===
                              "resubmission required")
                        }
                        helperText={
                          contactError.length > 0 && contactError[index].contact
                            ? "Invalid Number"
                            : ""
                        }
                      />
                      <TextField
                        select
                        sx={{ width: "32ch" }}
                        id={`sectionA-emergency-relationship-${index}`}
                        label="Select Relationship"
                        value={em.relationship}
                        error={
                          validateerror && validateerror[17][index]
                            ? validateerror[17][index].status
                            : ""
                        }
                        onChange={(e) =>
                          handleContact(e, index, "relationship")
                        }
                        required
                        disabled={
                          reduxUser.user.isAdmin &&
                          (newJoineeSectionAFlagButton === "pending" ||
                            newJoineeSectionAFlagButton === "submitted" ||
                            newJoineeSectionAFlagButton === "review done" ||
                            newJoineeSectionAFlagButton ===
                              "resubmission required")
                        }
                      >
                        <MenuItem value="mother">Mother</MenuItem>
                        <MenuItem value="father">Father</MenuItem>
                        <MenuItem value="spouse">Spouse</MenuItem>
                        <MenuItem value="sister">Sister</MenuItem>
                        <MenuItem value="brother">Brother</MenuItem>
                        <MenuItem value="son">Son</MenuItem>
                        <MenuItem value="daughter">Daughter</MenuItem>
                        <MenuItem value="guardian ">Guardian</MenuItem>
                      </TextField>
                    </div>
                  </Box>
                );
              })}
            </div>
          </section>

          <div className="col-11 ms-4 mb-4 border-bottom border-2"></div>
          <section className="col-12 mb-4 px-5 sodexoclass">
            <FormControlLabel
              onChange={(e) => handleSodexoChecked(e)}
              name="isSodexo"
              value={user.isSodexo}
              control={<Checkbox />}
              checked={user.isSodexo}
              label="Required Food Coupon"
              disabled={
                reduxUser.user.isAdmin &&
                (newJoineeSectionAFlagButton === "pending" ||
                  newJoineeSectionAFlagButton === "submitted" ||
                  newJoineeSectionAFlagButton === "review done" ||
                  newJoineeSectionAFlagButton === "resubmission required")
              }
            />

            {user.isSodexo ? (
              <FormControl sx={{ width: "25%" }}>
                <InputLabel id="demo-simple-select-label">
                  Food Coupon Value
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={user.sodexoCouponValue}
                  label="Food Coupon Value"
                  onChange={(e) => handleSodexoChange(e)}
                  disabled={
                    reduxUser.user.isAdmin &&
                    (newJoineeSectionAFlagButton === "pending" ||
                      newJoineeSectionAFlagButton === "submitted" ||
                      newJoineeSectionAFlagButton === "review done" ||
                      newJoineeSectionAFlagButton === "resubmission required")
                  }
                >
                  <MenuItem value={1100}>1100rs</MenuItem>
                  <MenuItem value={2200}>2200rs</MenuItem>
                </Select>
              </FormControl>
            ) : (
              <></>
            )}
          </section>

          <div className="col-11 ms-4 mb-4 border-bottom border-2"></div>
          <section className="col-12">
            {reduxUser.user.isAdmin ? (
              ""
            ) : (
              <div
                className="col-12 mb-5 px-5"
                id="sectionA-acknowledgement"
                data-section-a-error={ackError ? "true" : undefined}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={ackChecked}
                      onChange={(e) => {
                        setAckChecked(e.target.checked);
                        if (e.target.checked) setAckError(false);
                      }}
                    />
                  }
                  label="I acknowledge the details added by me are true"
                />
                {ackError && (
                  <div style={{ color: "red", marginTop: "4px" }}>
                    Please acknowledge the details added by you are true.
                  </div>
                )}
              </div>
            )}
            {newJoineeSectionAFlagButton === "review done" ||
            ((newJoineeSectionAFlagButton === "pending" ||
              newJoineeSectionAFlagButton === "submitted" ||
              newJoineeSectionAFlagButton === "resubmission required") &&
              reduxUser.user.isAdmin) ? (
              ""
            ) : (
              <div className="px-4 d-flex align-items-center">
                <div className="d-flex align-items-center">
                  {!reduxUser.user.isAdmin && (
                    <button
                      onClick={() => handleSaveDraft()}
                      type="button"
                      className="btn btn-outline-primary btn-lg px-5 me-4"
                      disabled={draftSaving}
                    >
                      Save Draft
                    </button>
                  )}
                  {loadingbutton ? (
                    <div className="me-4">
                      <LoadingButtons />
                    </div>
                  ) : (
                    <button
                      onClick={() => handleSubmit()}
                      type="button"
                      className="btn btn-primary btn-lg px-5 me-4"
                    >
                      Save
                    </button>
                  )}

                  <button
                    type="button"
                    onClick={() => handleResetAll()}
                    className="btn btn-outline-primary btn-lg px-5"
                  >
                    Clear All
                  </button>
                </div>

                {!reduxUser.user.isAdmin ? (
                  <DraftSavedAt className="ms-auto" date={lastDraftedAt} />
                ) : null}
              </div>
            )}
          </section>
        </div>
      </div>
    </div>
  );
}

export default SectionA;
